module.exports = __webpack_public_path__ + "img/logo.b5cd2653.svg";